<template>

</template>

<script>
  import { setIdToken, setAccessToken } from '../../utils/auth'
  import jwtDecode from 'jwt-decode'
  
  export default {
    name: '',
    mounted () {
      this.$nextTick(() => {
        setAccessToken()
        setIdToken()
        const token = localStorage.getItem(process.env.CLIENT_SECRET) // get token from local storage
        const decoded = jwtDecode(token) // decode token]
        const role = decoded && decoded.userRoles && decoded.userRoles[0] // extract roles from decoded token
        if (role === 'audit_user') {
          window.location.href = '/auditing/symptoms'
        } else if (role === 'apa_user') {
          window.location.href = '/file-upload/create'
        } else {
          const preLoginUrl = localStorage.getItem('preLoginUrl')
          // Redirect to the original URL or a default page if the original URL is not found
          window.location.href = preLoginUrl || '/summary'
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// callback.vue?683cdc8c